import { doNothing } from "@edgetier/utilities";
import { createContext } from "react";
import { IInteractionContext } from "./interaction-context.types";

export const defaultContext: IInteractionContext = {
    areWritingIssuesVisible: false,
    hasViewAgentPermission: false,
    isAddTagGroupSelectVisible: false,
    isTranslationActive: false,
    setAreWritingIssuesVisible: doNothing,
    setIsAddTagGroupSelectVisible: doNothing,
    setIsTranslationActive: doNothing,
};

export const InteractionContext = createContext(defaultContext);
